<form
  [formGroup]="form"
  (ngSubmit)="onSubmitRegistrationCategoryFilter()"
  #formRef="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsedRegCategoryFilter ? 'false' : 'true'"
          (click)="isCollapsedRegCategoryFilter = !isCollapsedRegCategoryFilter"
          aria-controls="registrationCategoryFilter"
        >
          <span class="fs-3">
            {{ 'general.registrationCategoryFilter' | translate }}
          </span>
          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedRegCategoryFilter ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsedRegCategoryFilter"
      class="card-body"
      id="registrationCategoryFilter"
    >
      <fieldset class="mb-4">
        <legend class="form-label" id="rcfDescLabel">{{
          'general.description' | translate
        }}</legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                aria-labelledby="rcfDescLabel flag-nl-1"
                formControlName="description_nl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="rcfDescLabel flag-en-1"
                formControlName="description_en"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                aria-labelledby="rcfDescLabel flag-fr-1"
                formControlName="description_fr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                aria-labelledby="rcfDescLabel flag-de-1"
                formControlName="description_de"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <div class="card-table">
        <table class="table border-bottom table-light table-sm">
          <thead>
            <tr>
              <th scope="col" id="catFilOrderLabel">
                {{ 'configurationOptionModule.ordinal' | translate }}
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['nl']"
                id="catFilNlLabel"
              >
                {{ 'general.name' | translate
                }}<span
                  role="img"
                  class="flag flag-nl ms-2"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['en']"
                id="catFilEnLabel"
              >
                {{ 'general.name' | translate
                }}<span
                  role="img"
                  class="flag flag-en ms-2"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['fr']"
                id="catFilFrLabel"
              >
                {{ 'general.name' | translate
                }}<span
                  role="img"
                  class="flag flag-fr ms-2"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span>
              </th>
              <th
                scope="col"
                *ngIf="availableLanguages['de']"
                id="catFilDeLabel"
              >
                {{ 'general.name' | translate
                }}<span
                  role="img"
                  class="flag flag-de ms-2"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span>
              </th>
              <th scope="col" colspan="2" id="catFilCatLabel">
                {{ 'general.belongingCategories' | translate }}
              </th>
            </tr>
          </thead>

          <tbody
            formArrayName="options"
            *ngFor="
              let options of regCategoryFilterOptionsFormArray.controls;
              let i = index
            "
          >
            <tr [formGroupName]="i">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  formControlName="ordinal"
                  aria-labelledby="catFilOrderLabel"
                />
              </td>
              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  aria-label=""
                  aria-describedby=""
                  formControlName="name_nl"
                  aria-labelledby="catFilNlLabel"
                />
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  aria-label=""
                  aria-describedby=""
                  formControlName="name_en"
                  aria-labelledby="catFilEnLabel"
                />
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  formControlName="name_fr"
                  aria-labelledby="catFilFrLabel"
                />
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  aria-labelledby="catFilDeLabel"
                  formControlName="name_de"
                />
              </td>
              <td>
                <ng-select
                  *ngIf="options$ | async"
                  class="d-block"
                  [items]="options$ | async"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchable]="true"
                  formControlName="belongingCategories"
                  bindLabel="name"
                  bindValue="optionId"
                  placeholder="{{ 'general.select' | translate }}"
                  [clearSearchOnAdd]="true"
                  aria-labelledby="catFilCatLabel"
                >
                </ng-select>
              </td>

              <td>
                <button
                  type="button"
                  class="btn btn-ghost-secondary"
                  (click)="deleteRegCatFilterOptionRow(i)"
                  [canSee]="[accessRights.ConfigurationOptions_delete]"
                >
                  <i
                    role="img"
                    class="fa fa-trash-alt"
                    attr.aria-label="{{ 'general.delete' | translate }}"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-start">
        <button
          class="btn btn-soft-primary btn-sm"
          type="button"
          (click)="addRegCatFilterOptionRow()"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.addRow' | translate }}
        </button>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
